import React from 'react';
import { UserProtocol } from '../../../types/protocols';
import './ProtocolCard.scss';

interface ProtocolCardProps {
  protocol: UserProtocol;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onView: (id: number) => void;
  onToggleStatus: (id: number, isActive: boolean) => void;
}

const ProtocolCard: React.FC<ProtocolCardProps> = ({
  protocol,
  onEdit,
  onDelete,
  onView,
  onToggleStatus,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const getStatusBadge = (isActive: boolean) => {
    return (
      <span 
        className={`status-badge ${isActive ? 'active' : 'inactive'}`}
        onClick={(e) => {
          e.stopPropagation();
          onToggleStatus(protocol.id, !isActive);
        }}
        title={`Переключить на ${isActive ? 'неактивный' : 'активный'}`}
      >
        {isActive ? 'Активен' : 'Неактивен'}
      </span>
    );
  };

  const getSpecialtyBadge = (specialty?: string) => {
    if (!specialty) return null;
    
    return (
      <span className="specialty-badge">
        {specialty}
      </span>
    );
  };

  return (
    <div className="protocol-card" onClick={() => onView(protocol.id)}>
      <div className="protocol-card__header">
        <h3 className="protocol-card__title">
          {protocol.name}
        </h3>
        {getStatusBadge(protocol.is_active)}
      </div>
      
      {protocol.specialty && (
        <div className="protocol-card__specialty">
          {getSpecialtyBadge(protocol.specialty)}
        </div>
      )}

      {protocol.description && (
        <p className="protocol-card__description">
          {protocol.description}
        </p>
      )}

      <div className="protocol-card__actions">
        <div className="protocol-card__date">
          Обновлен: {formatDate(protocol.updated_at)}
        </div>
        <div className="protocol-card__buttons">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(protocol.id);
            }}
          >
            Редактировать
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(protocol.id);
            }}
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProtocolCard;

